import { $t } from "@/lib/i18nHelpers";
import config from "@/config";
import { FormField, FormFields, ListFields } from "@/types";

export function personalIdFields(): (FormField & { meta?: Record<string, any> })[] {
  return [
    {
      name: "photo_container",
      type: "photoContainer",
      value: [
        {
          name: "id_photo",
          type: "inputFile",
          label: $t("Photo or scan of your ID"),
          meta: {
            required: config.featurePayeeInfoRequiredFields.includes("id_photo"),
          },
        },
        {
          name: "photo_with_id",
          type: "inputFile",
          label: $t("Photo of holding your ID"),
          meta: {
            required: config.featurePayeeInfoRequiredFields.includes("photo_with_id"),
          },
        },
      ],
    },

    ...(config.featureNSFW
      ? [
          { name: "acknowledgeAgreement", type: "checkbox" },
          { name: "sensitiveContent", type: "checkbox" },
        ]
      : []),
  ];
}

export const personalInfoFields: FormFields = [
  {
    name: "firstName",
    label: $t("First name"),
    rules: ["required"],
    validationMode: "aggressive",
  },
  {
    name: "lastName",
    label: $t("Last name"),
    rules: ["required"],
    validationMode: "aggressive",
  },
  {
    name: "phone",
    label: $t("Phone number"),
    type: "phone",
    validationMode: "aggressive",
  },
];

export const languageList: ListFields = [
  {
    text: $t("English"),
    value: "en",
  },
  {
    text: $t("Chinese"),
    value: "zh",
  },
  {
    text: $t("Spanish"),
    value: "es",
  },
  {
    text: $t("Arabic"),
    value: "ar",
  },
  {
    text: $t("French"),
    value: "fr",
  },
  {
    text: $t("Russian"),
    value: "ru",
  },
  {
    text: $t("Portuguese"),
    value: "pt",
  },
  {
    text: $t("German"),
    value: "de",
  },
  {
    text: $t("Japanese"),
    value: "ja",
  },
  {
    text: $t("Hindi"),
    value: "hi",
  },
  {
    text: $t("Bengali"),
    value: "bn",
  },
  {
    text: $t("Urdu"),
    value: "ur",
  },
  {
    text: $t("Korean"),
    value: "ko",
  },
  {
    text: $t("Italian"),
    value: "it",
  },
  {
    text: $t("Turkish"),
    value: "tr",
  },
  {
    text: $t("Vietnamese"),
    value: "vi",
  },
  {
    text: $t("Tamil"),
    value: "ta",
  },
  {
    text: $t("Greek"),
    value: "gr",
  },
  {
    text: $t("Dutch"),
    value: "nl",
  },
  {
    text: $t("Swedish"),
    value: "sv",
  },
  {
    text: $t("Afrikaans"),
    value: "af",
  },
  {
    text: $t("Hebrew"),
    value: "he",
  },
  {
    text: $t("Thai"),
    value: "th",
  },
];
